import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid';

import {useLoaderData, useNavigation, useLocation} from "react-router-dom";

import {isMobile} from "react-device-detect";

import {hasFullAccess, isLibrary} from "ultra/helpers/auth";
import {DEFAULT_CITY} from 'ultra/const/general';
import {getClientCity, getCityConfig} from 'ultra/configs/general';

import {useGlobalCustomContext} from '../../../../Helpers/context';
import {attachNodeImage} from '../../Helpers/user'; // attachUsersForFields
import {userHasNodesForCity} from '../../../../Helpers/user';

import {useContentStore} from '../../../../Stores/content';
import {useConfigStore} from '../../../../Stores/config';

import PreloaderTable from '../../../../Components/Preloaders/PreloaderTable';

import {TableView} from '../../../Content/Widgets/Table';
import BreadcrumbsWidget from '../../../Content/Widgets/Breadcrumbs';
import TitleWidget from '../../../Content/Widgets/Title';
import {getActions, NodeTableInlineActions} from '../../../Content/Widgets/NodeInlineActions';

// import {useBackdropPreloaderStore} from '../../../../Stores/backdropPreloader';

import {NODE_ACTIONS} from '../../../../Modules/Content/Reducers/node';
import FiltersLine from '../../../Content/Widgets/FiltersLine';
import {getLibrary} from '../../Helpers/library';

import UserNodesList from '../../Components/UserNodesList'

import {setPageTitle} from '../../../../Helpers/router';

import './index.scss';

export default () => {
    const rawNodes = useLoaderData();
    const navigation = useNavigation();

    const {configs} = useConfigStore();
    const {content, setContent} = useContentStore();

    const location = useLocation();

    const {nodeState, nodeDispatch} = useGlobalCustomContext();

    const {userState} = useGlobalCustomContext();

    const [city] = useState(getClientCity(window) || DEFAULT_CITY);
    const [fullAccess, setFullAccess] = useState();
    const [tableOptions, setTableOptions] = useState();
    const [fields, setFields] = useState();
    const [config, setConfig] = useState();
    const [inlineFilter, setInlineFilter] = useState();

    useEffect(() => {
        const bookFields = configs.content.nodes['book'].fields;
        bookFields._created_by.placeholder = "Власник"

        const fields = attachNodeImage(bookFields);

        fields.poster.placeholder = "Обгортка"

        if (isMobile) {
            fields.title.type = "book-title-with-status"
        } else {
            fields.status = {
                placeholder: "Статус",
                type: 'book-status'
            }
        }

        setFields(fields);

        setPageTitle('Бібліотека');
    }, [])

    useEffect(() => {
        if (userState?.user) {
            const fullAccess = hasFullAccess(userState?.user) || isLibrary(userState?.user) || false;

            const filterValues = {
                // reading: "Читаю"
                // given: "Передано почитати"
                // return: "Повертаю"

                // Заброньовані
                // overdue: "Перевищено строки повернення"
                // deposit: "Внести депозит"
                // take: "Віддати депозит"
            }

            let filterOrder = [
                // 'deposit',
                // 'reading',
                // 'return',
                // 'take',
                // 'given',
                // 'overdue',
            ]

            if (userState?.user?.library) {
                if (userState?.user?.library?.[city]?.reading > 0) {
                    if (userState?.user?.library?.[city]?.owner > 0 || fullAccess) {
                        filterOrder.push('notmine')
                        filterValues.notmine = `Читаю (${userState?.user?.library?.[city]?.reading})`;
                    }
                }

                if ((userState?.user?.library?.[city]?.owner > 0)) {
                    if (userState?.user?.library?.[city]?.reading > 0 || fullAccess) {
                        filterOrder.push('my')
                        filterValues.my = `Мої книги (${userState?.user?.library?.[city]?.owner})`;
                    }
                }
            }
            // else {
            //     filterValues.notmine = `Читаю`;
            //     filterValues.my = `Мої книги`;
            // }

            if (fullAccess) {
                filterValues['all_given'] = 'Всі активні книги';
                filterValues['all_overdue'] = 'Всі книги з перевищеними строками повернення';
                filterValues['all_deposit'] = 'Всі книги що чекають внесок депозиту';
                filterValues['all_return'] = 'Всі книги що чекають повернення депозиту'; //'Всі книги на стадії повернення';

                filterOrder = filterOrder
                    .concat([
                        'all_given',
                        'all_deposit',
                        'all_return',
                        'all_overdue',
                    ])
            }

            const complex = {
                id: 'books',
                field: {
                    default: fullAccess ? '' : userState?.user?.library?.[city]?.owner ? 'my' : 'notmine',
                    type: "complex",
                    placeholder: fullAccess ? "Фільтр" : "Мої книги",
                    options: {
                        hasNoEmptyValue: !fullAccess,
                        display: !fullAccess ? 'chips' : '', // && complex.field.options
                    },
                    values: {
                        values: filterValues,
                        order: filterOrder
                    }
                }
            }

            const config = {
                showFilters: {
                    filterBy: []
                }
            }

            // if (fullAccess || userState?.user?.library) {
            //     config.showFilters.filterBy.push({
            //         id: 'city',
            //         field: {
            //             type: "city",
            //             list: Object.keys(userState.user.library)
            //         }
            //     })
            // }

            if (fullAccess) {
                config.showFilters.filterBy.push(complex)
                config.showFilters.filterBy.push({
                    id: 'region',
                    field: {
                        placeholder: 'Район',
                        source: 'regions',
                        type: 'filter'
                    }
                })

                setConfig(config)
            }
            else if (filterOrder.length > 0){
                setInlineFilter([complex]);
            }


            let tableOptions;
            if (isMobile) {
                tableOptions = {
                    visible: ['_node_image', 'title'],
                    hidden: ['notes', 'region', 'deposit', 'maxTerm', 'author']
                }
            } else {
                tableOptions = {
                    visible: ['_node_image', 'title', 'status', 'region'],
                    hidden: ['notes', 'deposit', 'maxTerm', 'author']
                }
            }

            if (fullAccess) {
                tableOptions.hidden = [
                    '_reading_by',
                    ...tableOptions.hidden,
                    '_created_by',
                ]
            }

            tableOptions.hidden.push('_did')

            tableOptions.noHeaders = true

            setTableOptions(tableOptions)
            setFullAccess(fullAccess);
        }
    }, [userState?.user])

    useEffect(() => {
        if (nodeState.updatePageContentStart) {
            nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_END});

            // setContent({});
            getLibrary(city, location.search)
                .promise
                .then(setContent)
        }
    }, [nodeState.updatePageContentStart])

    useEffect(() => {
        if (navigation.state === 'idle') {
            setContent(rawNodes)
        }
    }, [navigation])

    const selectClasses = () => {}

    const title = {
        title: fullAccess === true ? 'Бібліотека' : 'Моя Бібліотека',
    }

    const permits = {
        children: {
            read: ['book']
        }
    }

    const breadcrumbs = {
        '\\': {
            title: getCityConfig(configs, city).city || 'Головна'
        }
    }

    return <div  className='Content'>
            <div className='AdminLibraryPage'>
                <TitleWidget permits={permits} content={title} config={config} breadcrumbs={breadcrumbs} />
                {title?.title && <BreadcrumbsWidget links={breadcrumbs} />}

                {!fields && <PreloaderTable/>}

                {(fullAccess === false) && <div className='MobileFiltersLine'>
                    <FiltersLine
                        size="small"
                        filters={inlineFilter}
                    />
                </div>}

                {fields && content?.children && <TableView
                    content={content.children}
                    fields={fields}
                    showPagination={true}
                    tableOptions={tableOptions}
                    selectClasses={selectClasses}

                    actionsComponent={NodeTableInlineActions}
                    actionsProps={{
                        unfolded: isMobile,
                        city,
                    }}
                    hasActions={(data, id) => getActions({
                        permits: data.permits[id],
                        node: data.list[id],
                        hasFullAccess: hasFullAccess(userState.user)
                    })}
                />}
            </div>

            {userState?.user && userHasNodesForCity(userState?.user?.nodes, city, 'book') > 0 && <Grid container spacing={1}>
                <Grid item xs={12}>
                    <UserNodesList list={userState.user.nodes.all} type="book"/>
                    {/* <div className='labelWrap labelWrapRow'>
                        <span className='label'>Статистика:</span>
                        <span className='labelValue'>
                            <UserNodesList list={userState.user.nodes.all} type="book"/>
                        </span>
                    </div> */}
                </Grid>
            </Grid>}

        </div>
}
